const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIntPrevired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e5330bab-78f7-4c79-9d2c-944a02a48e9b",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b64d179e-0756-4a95-b862-d25b1dd9ab4a{fill:#502a7f;}.a2069c14-4abe-4850-a795-72f4b1ff6afd{fill:#fcbb00;}")), /*#__PURE__*/React.createElement("rect", {
    className: "b64d179e-0756-4a95-b862-d25b1dd9ab4a",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M10.85,26a15.15,15.15,0,0,1,30.3-.23,15.15,15.15,0,0,1-30.3.23ZM26,39.83A14,14,0,0,0,40,26.16,14,14,0,1,0,26,39.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M33.93,30.68A2,2,0,0,1,32,32.59a2,2,0,0,1-2-2,2,2,0,0,1,2-1.89A1.92,1.92,0,0,1,33.93,30.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M27.94,14.94a1.82,1.82,0,0,1,1.91,1.94,1.86,1.86,0,0,1-2,1.84A2,2,0,0,1,26,16.8,1.9,1.9,0,0,1,27.94,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M21,26.09a1.87,1.87,0,0,1,2-1.83,1.92,1.92,0,0,1,1.93,1.95,2,2,0,0,1-2,1.87A2,2,0,0,1,21,26.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M27.85,37A1.89,1.89,0,0,1,26,35.11a1.93,1.93,0,0,1,2-1.85,1.86,1.86,0,0,1,1.83,1.94A1.84,1.84,0,0,1,27.85,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M33.93,21.14a1.88,1.88,0,0,1-1.88,1.91,2,2,0,0,1-2-1.88A2,2,0,0,1,32,19.24,1.93,1.93,0,0,1,33.93,21.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M33.36,26.13a1.82,1.82,0,0,1,1.9-1.88,1.85,1.85,0,0,1,1.91,1.88,1.92,1.92,0,0,1-1.87,1.95A1.89,1.89,0,0,1,33.36,26.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M31,26.15a2,2,0,0,1-2,1.93,1.94,1.94,0,0,1-1.89-1.93,1.87,1.87,0,0,1,1.89-1.9A1.92,1.92,0,0,1,31,26.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2069c14-4abe-4850-a795-72f4b1ff6afd",
    d: "M14.81,26.13a1.91,1.91,0,0,1,3.82,0,1.91,1.91,0,1,1-3.82,0Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntPrevired);
export default __webpack_public_path__ + "static/media/Int_PREVIRED.a1f8400a387b8976b77e79f799bdfc3c.svg";
export { ForwardRef as ReactComponent };